import { render, staticRenderFns } from "./BbmDetail.vue?vue&type=template&id=ca3325ea&scoped=true"
import script from "./BbmDetail.vue?vue&type=script&lang=js"
export * from "./BbmDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3325ea",
  null
  
)

export default component.exports